import { PartialMessageConstructor } from '@zg-rentals/backend-styled-components';

const RentalApplicationData = ({
  totalNumberOfApplications = 0,
  totalNumberOfApplicationsFetched = 0,
  applicationList = [],
  totalNumberOfActiveApplications = 0,
  totalNumberOfWithdrawnApplications = 0,
  totalNumberOfDeclinedApplications = 0,
  totalNumberOfInvitedApplications = 0,
} = {}) => ({
  totalNumberOfApplications: Number(totalNumberOfApplications),
  totalNumberOfApplicationsFetched: Number(totalNumberOfApplicationsFetched),
  applicationList: Array.isArray(applicationList) ? applicationList : [],
  totalNumberOfActiveApplications: Number(totalNumberOfActiveApplications),
  totalNumberOfWithdrawnApplications: Number(totalNumberOfWithdrawnApplications),
  totalNumberOfDeclinedApplications: Number(totalNumberOfDeclinedApplications),
  totalNumberOfInvitedApplications: Number(totalNumberOfInvitedApplications),
});

const ApplicationsSummary = ({
  listingAlias = '',
  isApplicationsEnabled = false,
  isApplicationsAccepted = false,
  isApplicationsAccessRestricted = false,
  rentalApplicationData = {},
  remainingSummaryCount = {
    remainingCount: 0,
    remainingCountNew: 0,
  },
  isFeed = true,
  userManagementFlags = {
    canEnableApplications: false,
    canRequestAccess: false,
    isPermissionRequestSent: false,
    isApplicationPermissionsEnabledForCompany: false,
    isEligible: false,
  },
  messageCode = '',
  partialMessages = [],
  title = '',
  urlPath = '',
} = {}) => ({
  listingAlias: String(listingAlias),
  isApplicationsEnabled: Boolean(isApplicationsEnabled),
  isApplicationsAccepted: Boolean(isApplicationsAccepted),
  isApplicationsAccessRestricted: Boolean(isApplicationsAccessRestricted),
  rentalApplicationData: RentalApplicationData(rentalApplicationData),
  remainingSummaryCount: Object(remainingSummaryCount),
  isFeed: Boolean(isFeed),
  userManagementFlags: Object(userManagementFlags),
  messageCode: String(messageCode),
  partialMessages: partialMessages.map((item) => PartialMessageConstructor(item)),
  title: String(title),
  urlPath: String(urlPath),
});

export type ApplicationsSummaryProps = ReturnType<typeof ApplicationsSummary>;

export default ApplicationsSummary;
